export const PIN_OFFSETS = {
    default: {
        marginToNextLine: 60,
        offsetTop: 24,
        offsetBottom: 24,
        offsetLeft: 45,
        offsetRight: 45,
    },
    groupsMarkers: {
        marginToNextLine: 12,
        offsetTop: 6,
        offsetBottom: 6,
        offsetLeft: 11,
        offsetRight: 11,
    },
};

export function getTextPosition(
    align,
    [x, y],
    pinSize,
    linesCount,
    marginToNextLine,
    offsets = PIN_OFFSETS.default
) {
    const offsetLines = (linesCount - 1) * marginToNextLine;
    let textX = 0;
    let textY = 0;
    let textAnchor = "middle";
    let textDominantBaseline = "hanging";

    switch (align) {
        case "top":
            textX = x;
            textY = y - pinSize.height - offsets.offsetTop - offsetLines;
            textAnchor = "middle";
            textDominantBaseline = "text-bottom";
            break;
        case "top-left":
            textX = x + pinSize.width / 2;
            textY = y - pinSize.height - offsets.offsetTop - offsetLines;
            textAnchor = "end";
            textDominantBaseline = "text-bottom";
            break;
        case "top-right":
            textX = x - pinSize.width / 2;
            textY = y - pinSize.height - offsets.offsetTop - offsetLines;
            textAnchor = "start";
            textDominantBaseline = "text-bottom";
            break;
        case "left":
            textX = x - offsets.offsetLeft;
            textY = y - pinSize.height / 2 - (offsetLines / 2);
            textAnchor = "end";
            textDominantBaseline = "central";
            break;
        case "right":
            textX = x + offsets.offsetRight;
            textY = y - pinSize.height / 2 - (offsetLines / 2);
            textAnchor = "start";
            textDominantBaseline = "central";
            break;
        case "bottom-left":
            textX = x + pinSize.width / 2;
            textY = y + offsets.offsetBottom;
            textAnchor = "end";
            textDominantBaseline = "hanging";
            break;
        case "bottom-right":
            textX = x - pinSize.width / 2;
            textY = y + offsets.offsetBottom;
            textAnchor = "start";
            textDominantBaseline = "hanging";
            break;
        case "bottom":
        default:
            textX = x;
            textY = y + offsets.offsetBottom;
            textAnchor = "middle";
            textDominantBaseline = "hanging";
            break;
    }
    return {textX, textY, textAnchor, textDominantBaseline};
}
